import React from "react";
import { View, Switch } from "react-native";
import { theme } from "../../../../theme";
import { Text } from "../../../Text/Text";
import { styles } from "./InputToggle.styles";
export const InputToggle = ({ color = "brand", label, styles: userStyles, onChange, ...rest }) => {
    return (React.createElement(View, { style: [styles.default, userStyles] },
        label && (React.createElement(Text, { fontSize: "small", styles: styles.label }, label)),
        React.createElement(Switch, { trackColor: {
                true: theme.colors[color].base,
                false: theme.colors.greyscale.lightest,
            }, ios_backgroundColor: theme.colors.greyscale.lightest, ...rest, onValueChange: (value) => onChange?.(value) })));
};
//# sourceMappingURL=InputToggle.js.map